import { CustomPropertyKeys } from '@reach/interfaces/custom-property/custom-property-id-keys';
import { BboxTypeEnum } from '@reach/interfaces/nodes/bbox-type.enum';
import { NodeType } from '@reach/interfaces/nodes/node-type.enum';

import { ClientNode } from '~ng-common-lib/nodes/types/node';

// TODO: Use the new type from `/chats` and only keep the group by node.

export enum SourcePreviewType {
	PDF = 'PDF',
	AUDIO = 'AUDIO',
	VIDEO = 'VIDEO',
	IMAGE = 'IMAGE',
	NOTES = 'NOTES',
	WEBSITE = 'WEBSITE',
	UNKNOWN = 'UNKNOWN',
}

export interface SourcePreviewByNodeSource {
	id: string;
	inlineNumber: number;

	content: string;

	data: {
		bboxType: BboxTypeEnum;
		boundingBox: {
			page: number;
			top: number;
			right: number;
			bottom: number;
			left: number;
		};
	};
}

export interface SourcePreviewByNode<NODE_TYPE extends NodeType = NodeType> {
	node: ClientNode<NODE_TYPE>;
	previewType: SourcePreviewType;
	sources: SourcePreviewByNodeSource[];
}

export const CREATION_DATE_KEYS = [
	CustomPropertyKeys.FILE_CREATION_DATE,
	CustomPropertyKeys.SHAREPOINT_CREATION_DATE,
	// CustomPropertyKeys.CREATION_DATE,
] as const;
